import clsx from 'clsx'
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {AsideMenu} from './AsideMenu'

const AsideDefault: FC = () => {
    const {config, classes} = useLayout()
    const {aside} = config

    return (
        <div
            id='kt_aside'
            className={clsx('aside', classes.aside.join(' '))}
            data-kt-drawer='true'
            data-kt-drawer-name='aside'
            data-kt-drawer-activate='{default: true, lg: false}'
            data-kt-drawer-overlay='true'
            data-kt-drawer-width="{default:'200px', '300px': '250px'}"
            data-kt-drawer-direction='start'
            data-kt-drawer-toggle='#kt_aside_mobile_toggle'
        >
            <div className='aside-logo flex-column-auto justify-content-center' id='kt_aside_logo'>
                <Link to='/'>
                    <img
                        alt='Logo'
                        className='h-40px logo'
                        src={toAbsoluteUrl('/media/logos/logo.png')}
                    />
                </Link>
                {aside.minimize && (
                    <div
                        id='kt_aside_toggle'
                        className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle'
                        data-kt-toggle='true'
                        data-kt-toggle-state='active'
                        data-kt-toggle-target='body'
                        data-kt-toggle-name='aside-minimize'
                    >
                        <i className='fas fa-angle-double-right svg-icon-1 rotate-180'></i>
                    </div>
                )}
            </div>
            <div className='aside-menu flex-column-fluid'>
                <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
            </div>
        </div>
    )
}

export {AsideDefault}
